import { SearchHighlightedSnippet } from '../SearchHighlightedSnippet'

import styles from '../../SearchModal.module.scss'

type SearchRowBodyProps = {
  title: string
  metaTag: string | null
  teaserRaw: string
  query: string
}

export function SearchRowBody({ title, metaTag, teaserRaw, query }: SearchRowBodyProps) {
  return (
    <span className={styles.itemBody}>
      <span className={styles.itemTitleRow}>
        <span className={styles.itemTitle}>{title}</span>
        {metaTag !== null ? <span className={styles.metaTag}>{metaTag}</span> : null}
      </span>

      {teaserRaw !== '' ? (
        <span className={styles.shortDesc}>
          <SearchHighlightedSnippet snippet={teaserRaw} query={query} highlightClassName={styles.highlight ?? ''} />
        </span>
      ) : null}
    </span>
  )
}
